import { clientAxios } from "../../../config"

export const getDivisionBikesData = async ({ fDate, eDate, division, date }) => {
    try {
        const resultGetDivisionBikesData = await clientAxios.get('/division-bikes.php', {
            params: {
                fDate,
                eDate,
                division,
                date
            }
        })

        const { result = [], message = "", msg_error = "" } = resultGetDivisionBikesData.data
        return { result, message, msg_error }

    } catch (error) {
        if ("response" in error) {
            const { response } = error
            const { data } = response
            const { result = [], message = "", error_msg = "" } = data
            return { result, message, error_msg }
        } else {
            const result = [], message = "An error has ocurred", error_msg = ""
            return { result, message, error_msg }
        }
    }
}